var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isWeChat)?_c('p',[_vm._v("正在配置微信JS-SDK权限...")]):_c('p',[_vm._v("不在微信中，无法使用微信JS-SDK。")])])
}
var staticRenderFns = []

export { render, staticRenderFns }